<template>
    <div class="wrapper">
        <v-head @changeColl="changeColl"></v-head>
        <v-sidebar :collapse="collapse"></v-sidebar>
        <div class="content-box" :class="{'content-collapse':collapse}">
            <v-tags></v-tags>
            <div class="content">
                <transition name="move" mode="out-in">
                    <keep-alive>
                        <router-view></router-view>
                    </keep-alive>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import vHead from "./components/HeadBar.vue";
import vSidebar from "./components/Sidebar.vue";
import vTags from "./components/Navbar.vue";
import * as echarts from "echarts";

export default {
  data() {
    return {
      collapse: false
    };
  },
  components: {
    vHead,
    vSidebar,
    vTags
  },
  created() {},
  methods: {
    changeColl() {
      this.collapse = !this.collapse;
      if (this.collapse) {
        this.resizeChart();
      }
    },
    resizeChart() {
      const chartDom = document.getElementById("myChart");
      if (chartDom) {
        var myChart = echarts.init(chartDom);
        myChart.resize();
      }
    }
  }
};
</script>
<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
.wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.content-box {
  position: absolute;
  left: 190px;
  right: 0;
  top: 70px;
  bottom: 0;
  overflow-y: auto;
  // min-height: calc(100vh - 70px);
  -webkit-transition: left 0.3s ease-in-out;
  -o-transition: left 0.3s ease-in-out;
  transition: left 0.3s ease-in-out;
  background: #fff;

  min-width: 1070px;

  .content {
    padding: 10px 10px 0;
  }
  &.content-collapse {
    left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue